import RedAsterisk from "../images/red-asterisk.svg?react";

/**Default: 14px by 14px */
export default function CoreRequiredIcon({
	height = 14,
	width = 14,
}: {
	width?: string | number;
	height?: string | number;
}) {
	return <RedAsterisk width={width} height={height} aria-hidden="true" />;
}
